import React, { useEffect, useState, createElement } from 'react';
import { Header } from '../components/heylloyd/Header';
import { HeroSection } from '../components/heylloyd/HeroSection';
import { StepSection } from '../components/heylloyd/StepSection';
import { LloydCard } from '../components/heylloyd/LloydCard';
import { DecisionGuide } from '../components/heylloyd/DecisionGuide';
import { FinalCTA } from '../components/heylloyd/FinalCTA';
import { Download, Monitor, Bot, Check, X } from 'lucide-react';
import { Button } from '../components/ui/Button';
// Declare fbq function for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function HeyLloydCustomsPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  useEffect(() => {
    // Initialize Meta Pixel
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', undefined, undefined, undefined);
    window.fbq('init', '1465116804947067');
    window.fbq('track', 'PageView');
  }, []);
  const handleCTAClick = (buttonName: string) => {
    // Fire AddToCart event when CTA button is clicked
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: buttonName,
        content_category: 'HeyLloyd Custom'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-cyan-100 selection:text-cyan-900" data-id="element-2109">
      {/* Meta Pixel noscript */}
      <noscript data-id="element-2110">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1465116804947067&ev=PageView&noscript=1" data-id="element-2111" />
      </noscript>

      <Header data-id="element-2112" />
      <div id="hero" data-id="element-2113">
        <HeroSection data-id="element-2114" />
      </div>
      {/* PASO 1 */}
      <div id="paso-1" data-id="element-2115">
        <StepSection stepNumber="1" title="Instala y abre HeyLloyd en tu computadora" data-id="element-2116">
          <p className="text-lg md:text-xl text-slate-600 mb-6 md:mb-8" data-id="element-2117">
            Primero, vamos a convertir tu computadora en una computadora con IA
            integrada. Sigue estos pasos sencillos:
          </p>
          <div className="mb-8 md:mb-10" data-id="element-2118">
            <a href="https://app.heylloyd.io/web-checkout" target="_blank" rel="noopener noreferrer" onClick={() => handleCTAClick('Descargar HeyLloyd')} data-id="element-2119">
              <Button variant="cyan" size="lg" className="w-full md:w-auto shadow-lg hover:shadow-xl" leftIcon={<Download className="w-5 h-5" data-id="element-2121" />} data-id="element-2120">
                Descargar HeyLloyd
              </Button>
            </a>
          </div>
          <div className="space-y-4 md:space-y-6" data-id="element-2122">
            <div className="flex gap-3 md:gap-4" data-id="element-2123">
              <div className="flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-cyan-100 text-cyan-700 flex items-center justify-center font-bold text-sm" data-id="element-2124">
                1
              </div>
              <div data-id="element-2125">
                <h4 className="font-bold text-slate-900 mb-1 text-sm md:text-base" data-id="element-2126">
                  Haz clic en "Get for Mac" o "Get for Windows"
                </h4>
                <p className="text-slate-600 text-sm md:text-base" data-id="element-2127">
                  Esto descargará el archivo de instalación de HeyLloyd en tu
                  computadora (normalmente en la carpeta "Descargas").
                </p>
              </div>
            </div>
            <div className="flex gap-3 md:gap-4" data-id="element-2128">
              <div className="flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-cyan-100 text-cyan-700 flex items-center justify-center font-bold text-sm" data-id="element-2129">
                2
              </div>
              <div data-id="element-2130">
                <h4 className="font-bold text-slate-900 mb-1 text-sm md:text-base" data-id="element-2131">
                  Abre el archivo descargado
                </h4>
                <p className="text-slate-600 text-sm md:text-base" data-id="element-2132">
                  Haz doble clic en el archivo. Se abrirá el instalador de
                  HeyLloyd. Sigue las instrucciones en pantalla hasta que
                  termine.
                </p>
              </div>
            </div>
            <div className="flex gap-3 md:gap-4" data-id="element-2133">
              <div className="flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-cyan-100 text-cyan-700 flex items-center justify-center font-bold text-sm" data-id="element-2134">
                3
              </div>
              <div data-id="element-2135">
                <h4 className="font-bold text-slate-900 mb-1 text-sm md:text-base" data-id="element-2136">
                  Haz clic en "Start Lloyd"
                </h4>
                <p className="text-slate-600 text-sm md:text-base" data-id="element-2137">
                  Cuando la instalación finalice, selecciona "Start Lloyd".
                  Verás una capa transparente sobre tu pantalla: ese es
                  HeyLloyd, listo para ayudarte.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-6 md:mt-8 p-3 md:p-4 bg-blue-50 border border-blue-100 rounded-lg text-blue-800 text-xs md:text-sm" data-id="element-2138">
            <strong data-id="element-2139">Nota:</strong> Si en algún momento te pierdes, vuelve al
            video de arriba y mira exactamente cómo lo hago en mi pantalla.
          </div>
        </StepSection>
      </div>
      {/* PASO 2 */}
      <div id="paso-2" data-id="element-2140">
        <StepSection stepNumber="2" title="Usa HeyLloyd mientras trabajas" bgColor="gray" data-id="element-2141">
          <p className="text-lg md:text-xl text-slate-600 mb-4 md:mb-6" data-id="element-2142">
            HeyLloyd es una superposición de escritorio transparente que se
            coloca sobre tu pantalla. Eso significa que:
          </p>
          <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-8" data-id="element-2143">
            <div className="bg-white p-4 md:p-6 rounded-xl border border-slate-200 shadow-sm" data-id="element-2144">
              <Monitor className="w-7 h-7 md:w-8 md:h-8 text-cyan-600 mb-3 md:mb-4" data-id="element-2145" />
              <h4 className="font-bold text-slate-900 mb-1 md:mb-2 text-sm md:text-base" data-id="element-2146">
                Tu pantalla de siempre
              </h4>
              <p className="text-slate-600 text-xs md:text-sm" data-id="element-2147">
                Ves tu computadora como siempre, pero ahora con IA integrada.
              </p>
            </div>
            <div className="bg-white p-4 md:p-6 rounded-xl border border-slate-200 shadow-sm" data-id="element-2148">
              <Bot className="w-7 h-7 md:w-8 md:h-8 text-cyan-600 mb-3 md:mb-4" data-id="element-2149" />
              <h4 className="font-bold text-slate-900 mb-1 md:mb-2 text-sm md:text-base" data-id="element-2150">
                Contexto automático
              </h4>
              <p className="text-slate-600 text-xs md:text-sm" data-id="element-2151">
                HeyLloyd ve lo que tú ves, entiende el contexto y te ayuda sin
                que tengas que cambiar de pestaña.
              </p>
            </div>
          </div>
          <ul className="space-y-2 md:space-y-3 mb-4 md:mb-6" data-id="element-2152">
            {['Abre cualquier aplicación o página donde estés trabajando.', 'Activa HeyLloyd (como viste en el video).', 'Pídele lo que necesites: HeyLloyd ya entiende qué hay en tu pantalla.'].map((item, i) => <li key={i} className="flex items-start text-slate-700 text-sm md:text-base" data-id="element-2153">
                <Check className="w-4 h-4 md:w-5 md:h-5 text-cyan-500 mr-2 md:mr-3 flex-shrink-0 mt-0.5" data-id="element-2154" />
                <span data-id="element-2155">{item}</span>
              </li>)}
          </ul>
          <p className="font-medium text-slate-900 italic border-l-4 border-cyan-500 pl-3 md:pl-4 text-sm md:text-base" data-id="element-2156">
            "Piensa en HeyLloyd como la capa de IA que le faltaba a tu
            computadora."
          </p>
        </StepSection>
      </div>
      {/* PASO 3 */}
      <div id="paso-3" data-id="element-2157">
        <StepSection stepNumber="3" title="Elige y usa tus Lloyds personalizados" data-id="element-2158">
          <p className="text-slate-600 mb-4 md:mb-6 text-sm md:text-base" data-id="element-2159">
            Dentro de HeyLloyd puedes usar <strong data-id="element-2160">Custom Lloyds</strong>: son
            bots especializados para tareas concretas (copy, investigación,
            etc.). Cada Lloyd está pre-configurado para guiarte paso a paso.
          </p>
          <div className="bg-slate-50 rounded-xl p-4 md:p-6 border border-slate-200 mb-6 md:mb-8" data-id="element-2161">
            <h4 className="font-bold text-slate-900 mb-3 md:mb-4 text-sm md:text-base" data-id="element-2162">
              Cómo funciona:
            </h4>
            <ol className="list-decimal list-inside space-y-1.5 md:space-y-2 text-slate-700 text-sm md:text-base" data-id="element-2163">
              <li data-id="element-2164">Descargas un archivo de Lloyd en tu computadora.</li>
              <li data-id="element-2165">Abres ese archivo con HeyLloyd.</li>
              <li data-id="element-2166">
                HeyLloyd carga ese bot y empieza a darte instrucciones claras.
              </li>
            </ol>
          </div>
          <div className="space-y-1.5 md:space-y-2" data-id="element-2167">
            <h4 className="font-bold text-slate-900 text-sm md:text-base" data-id="element-2168">
              Beneficios:
            </h4>
            <ul className="space-y-1.5 md:space-y-2 text-slate-600 text-sm md:text-base" data-id="element-2169">
              <li className="flex items-center" data-id="element-2170">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-2171" />
                No tienes que saber de prompts.
              </li>
              <li className="flex items-center" data-id="element-2172">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-2173" />
                No tienes que diseñar nada desde cero.
              </li>
              <li className="flex items-center" data-id="element-2174">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-2175" />
                Solo eliges, abres y sigues las indicaciones.
              </li>
            </ul>
          </div>
        </StepSection>
      </div>
      {/* GALLERY */}
      <section id="gallery" className="py-12 md:py-20 bg-slate-50 border-t border-slate-200" data-id="element-2176">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-2177">
          <div className="text-center mb-10 md:mb-16" data-id="element-2178">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-900 mb-3 md:mb-4 px-2" data-id="element-2179">
              Custom Lloyds Exclusivos
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto text-sm md:text-base px-2" data-id="element-2180">
              Lloyds especializados disponibles solo para estudiantes de 48 Hrs
              AI Cash Machine Academy
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mb-8 md:mb-12" data-id="element-2181">
            <LloydCard title="AI Product Builder" subtitle="Construcción de productos con IA" description="Tu asistente completo para crear productos digitales desde cero. HeyLloyd te guía en cada paso: desde la idea inicial hasta el lanzamiento, ayudándote a construir productos profesionales sin experiencia técnica." imageSrc="https://cdn.magicpatterns.com/uploads/q4SLHaHdAivvR2DiTEBLB4/hf_20260116_225721_4dc7f3c1-48e8-4206-b7a5-3ddf70d36f02.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="FREE - Value $97" onButtonClick={() => handleCTAClick('AI Product Builder')} data-id="element-2182" />
            <LloydCard title="Ebook Writer" subtitle="Escritura de ebooks" description="Perfecto para crear ebooks completos desde cero. HeyLloyd te guiará en la estructura, capítulos, y contenido para que escribas tu ebook paso a paso, directamente en tu pantalla. Only Available For Students Of 48 Hrs AI Cash Machine Academy - To unlock, become a member." imageSrc="https://cdn.magicpatterns.com/uploads/wN17SfcSENBgcMNUuXCiU3/hf_20260117_000004_e51b1569-2f2c-4476-a8b1-16bd3b0c149a.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="FREE - Value $97" onButtonClick={() => handleCTAClick('Ebook Writer')} data-id="element-2183" />
            <LloydCard title="Ebook Cover Designer" subtitle="Diseño de portadas" description="Especializado en crear portadas profesionales y atractivas para tus ebooks. HeyLloyd te guía en el diseño visual, tipografía y elementos gráficos para que tu ebook destaque y atraiga lectores. Only Available For Students Of 48 Hrs AI Cash Machine Academy - To unlock, become a member." imageSrc="https://cdn.magicpatterns.com/uploads/b14aCxx1KMK9dt11wkxhEQ/hf_20260117_000043_0d6fe8d3-9889-4c99-9732-0c2d3c868689.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="FREE - Value $97" onButtonClick={() => handleCTAClick('Ebook Cover Designer')} data-id="element-2184" />
            <LloydCard title="Meta Ads Decision Engine" subtitle="Optimización de anuncios" description="Motor de decisiones para tus campañas de Meta Ads. HeyLloyd te ayuda a analizar, optimizar y tomar decisiones estratégicas sobre tus anuncios de Facebook e Instagram en tiempo real. Only Available For Students Of 48 Hrs AI Cash Machine Academy - To unlock, become a member." imageSrc="https://cdn.magicpatterns.com/uploads/fP5h2DKoU4svvGzbLMWbJu/hf_20260117_000127_6ac5b4e1-6a69-4cc2-a2ec-321b5ded1fb4.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="FREE - Value $97" onButtonClick={() => handleCTAClick('Meta Ads Decision Engine')} data-id="element-2185" />
            <LloydCard title="The Viral PDF Lab" subtitle="PDFs virales" description="Laboratorio especializado en crear PDFs que se comparten masivamente. Ideal para lead magnets, recursos descargables y contenido que tu audiencia querrá compartir una y otra vez. Only Available For Students Of 48 Hrs AI Cash Machine Academy - To unlock, become a member." imageSrc="https://cdn.magicpatterns.com/uploads/2tNEnEu5UE3okfUmab7edk/hf_20260117_000148_2c4e2d0b-d01f-4fc2-9a59-f64c2f15a038.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="FREE - Value $97" onButtonClick={() => handleCTAClick('The Viral PDF Lab')} data-id="element-2186" />
            <LloydCard title="Sales Letter Weapon" subtitle="Cartas de ventas" description="Tu arma secreta para crear sales letters que convierten. HeyLloyd te ayudará a estructurar y escribir cartas de ventas persuasivas que generan resultados reales. Only Available For Students Of 48 Hrs AI Cash Machine Academy - To unlock, become a member." imageSrc="https://cdn.magicpatterns.com/uploads/5kGWUnrmKDQYXzDLEYEM4t/hf_20260116_235421_4c8d470f-9735-4fb6-a872-9980f950cb75_(1).png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="FREE - Value $97" onButtonClick={() => handleCTAClick('Sales Letter Weapon')} data-id="element-2187" />
            <LloydCard title="AI Business In A Box" subtitle="Negocio completo con IA" description="Sistema completo para lanzar tu negocio digital con IA. Incluye estrategia, herramientas, y procesos listos para implementar. Todo lo que necesitas para empezar tu negocio en un solo lugar. Only Available For Students Of 48 Hrs AI Cash Machine Academy - To unlock, become a member." imageSrc="https://cdn.magicpatterns.com/uploads/vZRGjeWsMWUmgY2TH7PWjr/hf_20260117_000209_aba255e4-f91b-4bed-b0d8-12b4f199acaf_(1).png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="FREE - Value $97" onButtonClick={() => handleCTAClick('AI Business In A Box')} data-id="element-2188" />
          </div>
          <div className="text-center bg-white p-4 md:p-6 rounded-xl border border-slate-200 max-w-2xl mx-auto shadow-sm" data-id="element-2189">
            <h4 className="font-bold text-slate-900 mb-2 flex items-center justify-center" data-id="element-2190">
              <Download className="w-4 h-4 mr-2 text-cyan-600" data-id="element-2191" />
              Acceso Exclusivo para Miembros
            </h4>
            <p className="text-sm text-slate-600" data-id="element-2192">
              Estos Custom Lloyds están disponibles únicamente para estudiantes
              de 48 Hrs AI Cash Machine Academy. Conviértete en miembro para
              desbloquear acceso completo.
            </p>
          </div>
        </div>
      </section>
      <DecisionGuide data-id="element-2193" />
      <FinalCTA onCTAClick={() => handleCTAClick('Empezar ahora con HeyLloyd - Final CTA')} data-id="element-2194" />

      {/* Footer */}
      <footer className="w-full relative z-10 bg-slate-900 border-t border-slate-800" data-id="element-2195">
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-4 md:py-6" data-id="element-2196">
          {/* Legal Disclaimer */}
          <div className="text-gray-300 text-[10px] leading-tight space-y-2 text-left" data-id="element-2197">
            <p data-id="element-2198">
              48 HRS AI CASH MACHINE y todo el equipo asociado no asume
              responsabilidad por los resultados, ingresos o éxito que puedas
              obtener, ni garantiza resultados específicos. El éxito depende en
              parte del tiempo que dediques y de tu implementación de las guías,
              estrategias y soporte proporcionados. Todo el contenido,
              entrenamientos, artículos y material educativo tiene fines
              formativos únicamente y no debe interpretarse como asesoría
              financiera, legal o de inversión.
            </p>

            <p data-id="element-2199">
              Aunque nuestros servicios, sistemas y productos están diseñados
              para ayudar a nuestros clientes a crear y lanzar productos
              digitales con IA, no ofrecemos garantías (explícitas o implícitas)
              sobre resultados, ventas o ingresos derivados del uso de las
              ideas, herramientas o estrategias presentadas.
            </p>

            <p data-id="element-2200">
              Los testimonios compartidos corresponden a experiencias reales de
              usuarios, pero no deben considerarse como resultados típicos, ya
              que cada persona obtiene resultados diferentes según su situación
              y las acciones que decida tomar.
            </p>

            <p data-id="element-2201">
              Cualquier cifra interna, ejemplo o caso de estudio mostrado tiene
              fines ilustrativos y no garantiza que tú obtendrás los mismos
              resultados.
            </p>

            <p data-id="element-2202">
              Este sitio no forma parte de Google, Google Inc., Facebook/Meta o
              Meta Inc.
            </p>

            <p data-id="element-2203">
              Además, este sitio no está avalado, patrocinado ni aprobado por
              Google ni Meta de ninguna manera.
            </p>
          </div>

          {/* Copyright */}
          <div className="text-center mt-4 pt-3 border-t border-gray-700" data-id="element-2204">
            <p className="text-gray-300 text-[10px] mb-1" data-id="element-2205">
              &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
            </p>
            <p className="text-gray-200 text-[10px] mb-1" data-id="element-2206">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#06b6d4] hover:text-[#0891b2] transition-colors" data-id="element-2207">
                support@truemarketer.com
              </a>
            </p>
            <div className="flex items-center justify-center gap-4 text-[10px]" data-id="element-2208">
              <button onClick={() => setShowTerms(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-2209">
                Términos
              </button>
              <span className="text-gray-400" data-id="element-2210">|</span>
              <button onClick={() => setShowPrivacy(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-2211">
                Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-2212">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-2213">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-2214">
              <X className="w-6 h-6" data-id="element-2215" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-2216">
              Términos y Condiciones
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-2217">
              <p data-id="element-2218">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2219">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-2220">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2221">
                2. Uso del Servicio
              </h3>
              <p data-id="element-2222">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2223">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-2224">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor. No está permitida la reproducción o
                distribución sin autorización expresa.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2225">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-2226">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2227">
                5. Modificaciones
              </h3>
              <p data-id="element-2228">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. El uso continuado del servicio después de
                cambios constituye la aceptación de los nuevos términos.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2229">Contacto</h3>
              <p data-id="element-2230">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-cyan-400 hover:text-cyan-300" data-id="element-2231">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-2232">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-2233">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-2234">
              <X className="w-6 h-6" data-id="element-2235" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-2236">
              Política de Privacidad
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-2237">
              <p data-id="element-2238">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad. Esta política describe cómo recopilamos, usamos y
                protegemos tu información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2239">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-2240">
                Recopilamos información que nos proporcionas directamente,
                incluyendo:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2241">
                <li data-id="element-2242">Nombre y dirección de correo electrónico</li>
                <li data-id="element-2243">Información de registro del evento</li>
                <li data-id="element-2244">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2245">
                2. Uso de la Información
              </h3>
              <p data-id="element-2246">Utilizamos tu información para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2247">
                <li data-id="element-2248">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-2249">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-2250">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-2251">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2252">
                3. Compartir Información
              </h3>
              <p data-id="element-2253">
                No vendemos ni compartimos tu información personal con terceros
                para fines de marketing. Podemos compartir información con
                proveedores de servicios que nos ayudan a operar nuestro
                negocio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2254">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-2255">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas para proteger tu información personal contra acceso
                no autorizado, alteración o destrucción.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2256">
                5. Tus Derechos
              </h3>
              <p data-id="element-2257">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal. Para ejercer estos derechos, contáctanos en:{' '}
                <a href="mailto:support@truemarketer.com" className="text-cyan-400 hover:text-cyan-300" data-id="element-2258">
                  support@truemarketer.com
                </a>
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2259">6. Cookies</h3>
              <p data-id="element-2260">
                Utilizamos cookies y tecnologías similares para mejorar tu
                experiencia en nuestro sitio web y analizar el uso del sitio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2261">Contacto</h3>
              <p data-id="element-2262">
                Para preguntas sobre esta política de privacidad, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-cyan-400 hover:text-cyan-300" data-id="element-2263">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}
    </div>;
}